import { render, staticRenderFns } from "./global-report.vue?vue&type=template&id=46186419"
import script from "./global-report.vue?vue&type=script&lang=js"
export * from "./global-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports